import { create } from 'zustand';
import { Category } from '@/common/types/databaseTypes';
import { categoryService } from '@/features/todo/services/categoryService';

interface CategoryState {
    categories: Category[];
    isLoading: boolean;
    error: Error | null;
    fetchCategories: () => Promise<void>;
}

export const useCategoryStore = create<CategoryState>(set => ({
    categories: [],
    isLoading: false,
    error: null,
    fetchCategories: async () => {
        try {
            set({ isLoading: true });
            const categories = await categoryService.getAllCategories();
            set({ categories, isLoading: false });
        } catch (error) {
            set({ error: error as Error, isLoading: false });
        }
    },
}));

// 앱 초기화 시 카테고리 로드
export const initializeCategories = async () => {
    const { categories, fetchCategories } = useCategoryStore.getState();
    if (categories.length === 0) {
        await fetchCategories();
    }
};
